/**
 * @module Constants/formats
 * */

/**
 * @constant {String} - формат даты 'DD.MM.YYYY'
 * */
export const DATE = 'DD.MM.YYYY'

/**
 * @constant {String} - формат времени 'hh:mm:ss'
 * */
export const TIME = 'hh:mm:ss'

/**
 * @constant {String} - формат номера телефона
 * */
export const PHONE = '## (###) ###-##-##'
